import rolePermission from '@/constants/rolePermission';
import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const Material: AppRouteRecordRaw = {
  path: '/material',
  name: 'Material',
  redirect: '/material/index',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '物料管理',
    requiresAuth: true,
    icon: 'icon-file',
    order: 3,
  },
  children: [
    {
      path: 'index',
      name: 'MaterialList',
      component: () => import('@/views/material/index.vue'),
      meta: {
        title: '物料信息',
        requiresAuth: true,
        roles: ['materialGet'],
        menuIcon: 'icon-wuliaoguanli',
      },
    },
    {
      path: 'add-material',
      name: 'AddMaterial',
      component: async () => {
        const cpn = await import(
          '@/views/material/components/addOrEditMaterial.vue'
        );
        return { ...cpn.default, name: 'AddMaterial' };
      },
      props: (route: any) => ({
        id: route.query.id,
        isCopy: route.query.isCopy,
      }),
      meta: {
        title: '新增物料',
        hideInMenu: true,
        requiresAuth: true,
        roles: ['materialEdit'],
        noScrollStorage: true, // 新增页需要该字段，表示不需要使用记住的滚动位置
      },
    },
    {
      path: 'edit-material',
      name: 'EditMaterial',
      component: async () => {
        const cpn = await import(
          '@/views/material/components/addOrEditMaterial.vue'
        );
        return { ...cpn.default, name: 'EditMaterial' };
      },
      props: (route: any) => ({
        id: route.query.id,
        isCopy: route.query.isCopy,
      }),
      meta: {
        title: '编辑物料',
        hideInMenu: true,
        requiresAuth: true,
        roles: ['materialGet'],
      },
    },
    {
      path: 'import-material',
      name: 'ImportMaterial',
      component: async () => {
        const cpn = await import('@/views/material/importMaterial/index.vue');
        return { ...cpn.default, name: 'ImportMaterial' };
      },
      meta: {
        title: '导入物料',
        requiresAuth: true,
        roles: ['materialEdit'],
        hideInMenu: true,
      },
    },
    // {
    //   path: 'material-stock',
    //   name: 'MaterialStock',
    //   component: () => import('@/views/temporaryTemplate/index.vue'),
    //   meta: {
    //     title: '物料库存',
    //     requiresAuth: true,
    //     roles: ['*'],
    //     notOnline: true,
    //   },
    // },
    {
      path: 'material-center',
      name: 'MaterialCenter',
      component: () => import('@/views/material/materialCenter/index.vue'),
      meta: {
        title: '用料中心',
        requiresAuth: true,
        roles: ['goodsDataMaterialBaseGet'],
        menuIcon: 'icon-yongliaozhongxin',
      },
    },
    {
      path: 'material-intelligent-purchase',
      name: 'MaterialIntelligentPurchase',
      component: () =>
        import('@/views/material/materialIntelligentPurchase/index.vue'),
      meta: {
        title: '采购中台',
        requiresAuth: true,
        roles: ['materialPurchaseOrderSubmit'],
        hideInMenu: true,
      },
    },
    {
      path: 'material-purchase',
      name: 'MaterialPurchase',
      component: () => import('@/views/material/materialPurchase/index.vue'),
      meta: {
        title: '物料采购',
        requiresAuth: true,
        roles: ['materialPurchaseOrderGet'],
        notOnline: false,
        menuIcon: 'icon-wuliaocaigou',
      },
    },
    {
      path: 'material-purchase-compose-add',
      name: 'AddComposeMtPurchase',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialPurchase/composeAddOrEdit.vue'
        );
        return { ...cpn.default, name: 'AddComposeMtPurchase' };
      },
      meta: {
        title: '新增物料采购组合',
        requiresAuth: true,
        roles: rolePermission.materialPurchaseOrderEdit,
        permissionMode: 'some',
        notOnline: true,
        hideInMenu: true,
        noScrollStorage: true, // 新增页需要该字段，表示不需要使用记住的滚动位置
      },
    },
    {
      path: 'material-purchase-compose-edit',
      name: 'EditComposeMtPurchase',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialPurchase/composeAddOrEdit.vue'
        );
        return { ...cpn.default, name: 'AddComposeMtPurchase' };
      },
      meta: {
        title: '编辑物料采购组合',
        requiresAuth: true,
        roles: ['materialPurchaseOrderGet'],
        notOnline: true,
        hideInMenu: true,
      },
    },
    {
      path: 'material-purchase-compose-detail',
      name: 'ComposeMtPurchaseDetail',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialPurchase/composePurDetail.vue'
        );
        return { ...cpn.default, name: 'ComposeMtPurchaseDetail' };
      },
      meta: {
        title: '物料采购组合详情',
        requiresAuth: true,
        roles: ['materialPurchaseOrderGet'],
        notOnline: true,
        hideInMenu: true,
      },
    },
    {
      path: 'material-purchase-add',
      name: 'AddMaterialPurchase',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialPurchase/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'AddMaterialPurchase' };
      },
      meta: {
        title: '新增物料采购',
        requiresAuth: true,
        roles: rolePermission.materialPurchaseOrderEdit,
        permissionMode: 'some',
        notOnline: true,
        hideInMenu: true,
        noScrollStorage: true, // 新增页需要该字段，表示不需要使用记住的滚动位置
      },
    },
    {
      path: 'material-purchase-edit',
      name: 'EditMaterialPurchase',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialPurchase/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'EditMaterialPurchase' };
      },
      meta: {
        title: '编辑物料采购',
        requiresAuth: true,
        roles: ['materialPurchaseOrderGet'],
        notOnline: true,
        hideInMenu: true,
      },
    },
    {
      path: 'material-purchase-detail',
      name: 'MaterialPurchaseDetail',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialPurchase/purDetail.vue'
        );
        return { ...cpn.default, name: 'MaterialPurchaseDetail' };
      },
      meta: {
        title: '物料采购详情',
        requiresAuth: true,
        roles: ['materialPurchaseOrderGet'],
        notOnline: true,
        hideInMenu: true,
      },
    },
    {
      path: 'purchase-business-print',
      name: 'PurchaseBusinessTemplate',
      component: () =>
        import(
          '@/views/material/materialPurchase/components/purchase-template.vue'
        ),
      props: (route: any) => ({
        ordersSn: route.query.ordersSn,
      }),
      meta: {
        title: '采购单打印',
        requiresAuth: false,
        hideInMenu: true,
        iframe: true,
      },
    },
    {
      path: 'material-delivery',
      name: 'MaterialDelivery',
      component: () => import('@/views/material/materialDelivery/index.vue'),
      meta: {
        title: '物料发货',
        requiresAuth: true,
        roles: ['materialDeliveryOrderGet'],
        menuIcon: 'icon-wuliaofahuo',
      },
    },
    {
      path: 'material-delivery-detail',
      name: 'MaterialDeliveryDetail',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialDelivery/materialDeliveryDetail.vue'
        );
        return { ...cpn.default, name: 'MaterialDeliveryDetail' };
      },
      meta: {
        title: '物料发货记录',
        requiresAuth: true,
        roles: ['materialDeliveryOrderGet'],
        hideInMenu: true,
        ignoreCache: true,
      },
    },
    {
      path: 'material-delivery-add',
      name: 'MaterialDeliveryAdd',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialDelivery/materialDeliveryAddOrEdit.vue'
        );
        return { ...cpn.default, name: 'MaterialDeliveryAdd' };
      },
      meta: {
        title: '新增物料发货',
        requiresAuth: true,
        roles: ['materialDeliveryOrderSend'],
        hideInMenu: true,
        noScrollStorage: true, // 新增页需要该字段，表示不需要使用记住的滚动位置
      },
    },
    {
      path: 'material-delivery-edit',
      name: 'MaterialDeliveryEdit',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialDelivery/materialDeliveryAddOrEdit.vue'
        );
        return { ...cpn.default, name: 'MaterialDeliveryEdit' };
      },
      meta: {
        title: '编辑物料发货',
        requiresAuth: true,
        roles: ['materialDeliveryOrderGet'],
        hideInMenu: true,
      },
    },
    {
      path: 'material-all-delivery',
      name: 'MaterialAllDelivery',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialDelivery/materialAllDelivery.vue'
        );
        return { ...cpn.default, name: 'MaterialAllDelivery' };
      },
      meta: {
        title: '物料全发货',
        requiresAuth: true,
        roles: ['materialDeliveryOrderSend'],
        hideInMenu: true,
      },
    },
    {
      path: 'material-take-delivery-in-store',
      name: 'MaterialTakeDeliveryInStore',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialDelivery/materialTakeDeliveryInStore.vue'
        );
        return { ...cpn.default, name: 'MaterialTakeDeliveryInStore' };
      },
      meta: {
        title: '物料入库',
        requiresAuth: true,
        roles: ['materialStoreInOrderGet'],
        hideInMenu: true,
      },
    },
    {
      path: 'material-delivery-in-store',
      name: 'MaterialDeliveryInStore',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialDelivery/materialTakeDeliveryInStore.vue'
        );
        return { ...cpn.default, name: 'MaterialDeliveryInStore' };
      },
      meta: {
        title: '物料收货入库',
        requiresAuth: true,
        roles: ['materialDeliveryOrderGet'],
        hideInMenu: true,
      },
    },
    {
      path: 'material-purchase-retail',
      name: 'MaterialPurchaseRetail',
      component: () =>
        import('@/views/material/materialPurchaseRetail/index.vue'),
      meta: {
        title: '物料采购退货',
        requiresAuth: true,
        roles: ['materialPurchaseRefundOrderGet'],
        menuIcon: 'icon-wuliaocaigoutuihuo',
      },
    },
    {
      path: 'material-purchase-retail-add',
      name: 'AddMaterialPurchaseRetail',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialPurchaseRetail/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'AddMaterialPurchaseRetail' };
      },
      meta: {
        title: '新增物料采购退货单',
        requiresAuth: true,
        roles: rolePermission.materialPurchaseRefundOrderEdit,
        permissionMode: 'some',
        hideInMenu: true,
        noScrollStorage: true, // 新增页需要该字段，表示不需要使用记住的滚动位置
      },
    },
    {
      path: 'material-purchase-retail-edit',
      name: 'EditMaterialPurchaseRetail',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialPurchaseRetail/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'EditMaterialPurchaseRetail' };
      },
      meta: {
        title: '编辑物料采购退货单',
        requiresAuth: true,
        roles: ['materialPurchaseRefundOrderGet'],
        hideInMenu: true,
      },
    },
    {
      path: 'material-purchase-retail-detail',
      name: 'MaterialPurchaseRetailDetail',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialPurchaseRetail/purchRetailDetail.vue'
        );
        return { ...cpn.default, name: 'MaterialPurchaseRetailDetail' };
      },
      meta: {
        title: '物料采购退货单详情',
        requiresAuth: true,
        roles: ['materialPurchaseRefundOrderGet'],
        hideInMenu: true,
      },
    },
    {
      path: 'material-send',
      name: 'MaterialSend',
      component: () => import('@/views/material/materialSend/index.vue'),
      meta: {
        title: '物料发料',
        requiresAuth: true,
        sysConfigKey: 'isOpenMaterialIssue', // 系统配置的configKey，没有默认展示
        defaultValue: 0, // sysConfigKey的默认值，新用户取不到就会取默认值，没有设置默认展示
        roles: ['materialIssueOrderGet'],
        menuIcon: 'icon-wuliaofahuo',
      },
    },
    {
      path: 'material-send-detail',
      name: 'MaterialSendDetail',
      component: () => import('@/views/material/materialSend/detail.vue'),
      meta: {
        title: '物料发料详情',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['materialIssueOrderGet'],
      },
    },
    {
      path: 'material-send-detail-add',
      name: 'MaterialSendDetailAdd',
      component: async () => {
        const cpn = await import('@/views/material/materialSend/addOrEdit.vue');
        return { ...cpn.default, name: 'MaterialSendDetailAdd' };
      },
      meta: {
        title: '物料发料详情',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['materialIssueOrderGet'],
      },
    },
    {
      path: 'material-send-add',
      name: 'MaterialSendAdd',
      component: async () => {
        const cpn = await import('@/views/material/materialSend/addOrEdit.vue');
        return { ...cpn.default, name: 'MaterialSendAdd' };
      },
      meta: {
        title: '新增物料发料',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['materialIssueOrderSubmit'],
        noScrollStorage: true, // 新增页需要该字段，表示不需要使用记住的滚动位置
      },
    },
    {
      path: 'material-send-edit',
      name: 'MaterialSendEdit',
      component: async () => {
        const cpn = await import('@/views/material/materialSend/addOrEdit.vue');
        return { ...cpn.default, name: 'MaterialSendEdit' };
      },
      meta: {
        title: '编辑物料发料',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['materialIssueOrderGet'],
      },
    },
    {
      path: 'material-picking',
      name: 'MaterialPicking',
      component: async () => {
        const cpn = await import('@/views/material/materialPicking/index.vue');
        return { ...cpn.default, name: 'MaterialPicking' };
      },
      meta: {
        title: '物料领料',
        requiresAuth: true,
        roles: ['materialPickOrderGet'],
        notOnline: false,
        menuIcon: 'icon-wuliaolingliao',
      },
    },
    {
      path: 'material-picking-add',
      name: 'AddMaterialPicking',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialPicking/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'AddMaterialPicking' };
      },
      props: (route: any) => ({
        businessSn: route.query.businessSn,
        produceBatchSn: route.query.produceBatchSn,
      }),
      meta: {
        title: '新增物料领料单',
        requiresAuth: true,
        roles: rolePermission.materialPickOrderEdit,
        permissionMode: 'some',
        notOnline: true,
        hideInMenu: true,
        noScrollStorage: true, // 新增页需要该字段，表示不需要使用记住的滚动位置
      },
    },
    {
      path: 'material-picking-edit',
      name: 'EditMaterialPicking',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialPicking/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'EditMaterialPicking' };
      },
      meta: {
        title: '编辑物料领料单',
        requiresAuth: true,
        roles: ['materialPickOrderGet'],
        notOnline: true,
        hideInMenu: true,
      },
    },
    {
      path: 'material-picking-detail',
      name: 'MaterialPickingDetail',
      component: async () => {
        const cpn = await import('@/views/material/materialPicking/detail.vue');
        return { ...cpn.default, name: 'MaterialPickingDetail' };
      },
      meta: {
        title: '物料领料单详情',
        requiresAuth: true,
        roles: ['materialPickOrderGet'],
        notOnline: true,
        hideInMenu: true,
        ignoreCache: true,
      },
    },
    {
      path: 'material-picking-return',
      name: 'MaterialPickingReturn',
      component: async () => {
        const cpn = await import('@/views/material/materialPicking/index.vue');
        return { ...cpn.default, name: 'MaterialPickingReturn' };
      },
      meta: {
        title: '领料退料',
        requiresAuth: true,
        roles: ['materialRefundOrderGet'],
        notOnline: false,
        menuIcon: 'icon-lingliaotuiliao',
      },
    },
    {
      path: 'material-picking-return-add',
      name: 'AddMaterialPickingReturn',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialPicking/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'AddMaterialPickingReturn' };
      },
      meta: {
        title: '新增领料退料单',
        requiresAuth: true,
        roles: rolePermission.materialRefundOrderEdit,
        permissionMode: 'some',
        notOnline: true,
        hideInMenu: true,
        noScrollStorage: true, // 新增页需要该字段，表示不需要使用记住的滚动位置
      },
    },
    {
      path: 'material-picking-return-edit',
      name: 'EditMaterialPickingReturn',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialPicking/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'EditMaterialPickingReturn' };
      },
      meta: {
        title: '编辑领料退料单',
        requiresAuth: true,
        roles: ['materialRefundOrderGet'],
        notOnline: true,
        hideInMenu: true,
      },
    },
    {
      path: 'material-picking-return-detail',
      name: 'MaterialPickingReturnDetail',
      component: async () => {
        const cpn = await import('@/views/material/materialPicking/detail.vue');
        return { ...cpn.default, name: 'MaterialPickingReturnDetail' };
      },
      meta: {
        title: '领料退料单详情',
        requiresAuth: true,
        roles: ['materialRefundOrderGet'],
        notOnline: true,
        hideInMenu: true,
        ignoreCache: true,
      },
    },
    {
      path: 'material-recovery',
      name: 'MaterialRecovery',
      component: () => import('@/views/material/materialRecovery/index.vue'),
      meta: {
        title: '物料回料',
        requiresAuth: true,
        sysConfigKey: 'isOpenMaterialIssue', // 系统配置的configKey，没有默认展示
        defaultValue: 0, // sysConfigKey的默认值，新用户取不到就会取默认值，没有设置默认展示
        roles: ['materialRecoveryOrderGet'],
        menuIcon: 'icon-wuliaohuiliao',
      },
    },
    {
      path: 'material-recovery-detail',
      name: 'MaterialRecoveryDetail',
      component: () => import('@/views/material/materialRecovery/detail.vue'),
      meta: {
        title: '物料回料详情',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['materialRecoveryOrderGet'],
      },
    },
    {
      path: 'material-recovery-add',
      name: 'MaterialRecoveryAdd',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialRecovery/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'MaterialRecoveryAdd' };
      },
      meta: {
        title: '新增物料回料',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['materialRecoveryOrderSubmit'],
        noScrollStorage: true, // 新增页需要该字段，表示不需要使用记住的滚动位置
      },
    },
    {
      path: 'material-recovery-edit',
      name: 'MaterialRecoveryEdit',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialRecovery/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'MaterialRecoveryEdit' };
      },
      meta: {
        title: '编辑物料回料',
        requiresAuth: true,
        hideInMenu: true,
        roles: ['materialRecoveryOrderGet'],
      },
    },
    {
      path: 'material-store-in',
      name: 'MaterialStoreIn',
      component: () => import('@/views/material/materialStoreIn/index.vue'),
      meta: {
        title: '物料入库',
        requiresAuth: true,
        roles: ['materialStoreInOrderGet'],
        notOnline: false,
        menuIcon: 'icon-wuliaoruku',
      },
    },
    {
      path: 'material-all-store-in',
      name: 'MaterialAllStoreIn',
      component: () =>
        import('@/views/material/materialStoreIn/allStoreIn.vue'),
      meta: {
        title: '采购组合单全入库',
        requiresAuth: true,
        roles: ['materialStoreInOrderSubmit'],
        hideInMenu: true,
      },
    },
    {
      path: 'material-store-in-edit',
      name: 'MaterialStoreInOrder',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialStoreIn/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'MaterialStoreInOrder' };
      },
      meta: {
        title: '物料入库单',
        requiresAuth: true,
        roles: ['materialStoreInOrderGet'],
        notOnline: true,
        hideInMenu: true,
      },
    },
    {
      path: 'material-store-out',
      name: 'MaterialStoreOut',
      component: () => import('@/views/material/materialStoreOut/index.vue'),
      meta: {
        title: '物料出库',
        requiresAuth: true,
        roles: ['materialStoreOutOrderGet'],
        notOnline: false,
        menuIcon: 'icon-wuliaochuku',
      },
    },
    {
      path: 'material-store-out-edit',
      name: 'MaterialStoreOutOrder',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialStoreOut/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'MaterialStoreOutOrder' };
      },
      meta: {
        title: '物料出库单',
        requiresAuth: true,
        roles: ['materialStoreOutOrderGet'],
        notOnline: true,
        hideInMenu: true,
      },
    },
    {
      path: 'material-inventory',
      name: 'MaterialInventory',
      component: () => import('@/views/material/materialInventory/index.vue'),
      meta: {
        title: '物料盘点',
        requiresAuth: true,
        roles: ['materialStoreOrderGet'],
        menuIcon: 'icon-wuliaopandian',
      },
    },
    {
      path: 'material-inventory-add',
      name: 'AddMaterialInventory',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialInventory/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'AddMaterialInventory' };
      },
      meta: {
        title: '新增物料盘点',
        requiresAuth: true,
        roles: rolePermission.materialStoreOrderEdit,
        permissionMode: 'some',
        notOnline: true,
        hideInMenu: true,
        noScrollStorage: true, // 新增页需要该字段，表示不需要使用记住的滚动位置
      },
    },
    {
      path: 'material-inventory-details',
      name: 'MaterialInventoryDetails',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialInventory/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'MaterialInventoryDetails' };
      },
      props: (route: any) => ({
        ordersSn: route.query.ordersSn,
      }),
      meta: {
        title: '物料盘点详情',
        requiresAuth: true,
        roles: ['materialStoreOrderGet'],
        notOnline: true,
        hideInMenu: true,
        ignoreCache: true,
      },
    },
    {
      path: 'material-inventory-edit',
      name: 'EditMaterialInventory',
      component: async () => {
        const cpn = await import(
          '@/views/material/materialInventory/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'EditMaterialInventory' };
      },
      props: (route: any) => ({
        ordersSn: route.query.ordersSn,
      }),
      meta: {
        title: '编辑物料盘点',
        requiresAuth: true,
        roles: ['materialStoreOrderGet'],
        notOnline: true,
        hideInMenu: true,
      },
    },
    {
      path: 'material-store-transfer',
      name: 'MaterialStoreTransfer',
      component: async () => {
        const cpn = await import('@/views/material/storeTransfer/index.vue');
        return { ...cpn.default, name: 'MaterialStoreTransfer' };
      },
      meta: {
        title: '物料调拨',
        requiresAuth: true,
        roles: ['materialStoreTransferOrderGet'],
        menuIcon: 'icon-wuliaotiaobo',
      },
    },
    {
      path: 'material-store-add',
      name: 'AddMaterialStore',
      component: async () => {
        const cpn = await import(
          '@/views/material/storeTransfer/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'AddMaterialStore' };
      },
      meta: {
        title: '新增物料调拨',
        requiresAuth: true,
        roles: rolePermission.materialStoreTransferOrderEdit,
        permissionMode: 'some',
        notOnline: true,
        hideInMenu: true,
        noScrollStorage: true, // 新增页需要该字段，表示不需要使用记住的滚动位置
      },
    },
    {
      path: 'detail-material-store',
      name: 'DetailMaterialStore',
      component: async () => {
        const cpn = await import(
          '@/views/material/storeTransfer/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'DetailMaterialStore' };
      },
      meta: {
        title: '物料调拨详情',
        requiresAuth: true,
        roles: ['materialStoreTransferOrderGet'],
        notOnline: true,
        hideInMenu: true,
        ignoreCache: true,
      },
    },
    {
      path: 'material-store-edit',
      name: 'EditMaterialStore',
      component: async () => {
        const cpn = await import(
          '@/views/material/storeTransfer/addOrEdit.vue'
        );
        return { ...cpn.default, name: 'EditMaterialStore' };
      },
      meta: {
        title: '编辑物料调拨',
        requiresAuth: true,
        roles: ['materialStoreTransferOrderGet'],
        notOnline: true,
        hideInMenu: true,
      },
    },
    {
      path: 'material-stock-detail',
      name: 'MaterialStockDetail',
      component: () => import('@/views/material/materialStockDetail/index.vue'),
      meta: {
        title: '物料库存流水',
        requiresAuth: true,
        roles: ['materialStoredRecordGet'],
        menuIcon: 'icon-wuliaokucunliushui',
      },
    },
    {
      path: 'material-process-recover-detail',
      name: 'MaterialProcessRecoverDetail',
      component: () =>
        import('@/views/material/components/processRecoverDetail.vue'),
      props: (route: any) => ({
        ordersSn: route.query.ordersSn,
      }),
      meta: {
        title: '加工回收单详情',
        requiresAuth: true,
        roles: ['outwardOrderGet'],
        ignoreCache: true,
        hideInMenu: true,
      },
    },
    {
      path: 'sku-material-batch-import',
      name: 'SKUMaterialBatchImport',
      component: () => import('@/test/skuMaterialBatchImport.vue'),
      meta: {
        title: '物料批量导入(测试)',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
  ],
};

export default Material;
